// Ajustes do tema só do dashboard. Abaixo de xl (notebooks, ~1366px) o
// dashboard fica compacto: fonte menor e componentes no tamanho small/dense,
// para caber mais conteúdo sem precisar de zoom no navegador.
const compactOptions = {
  typography: { fontSize: 13 },
  components: {
    MuiTextField: { defaultProps: { size: 'small' } },
    MuiFormControl: { defaultProps: { size: 'small' } },
    MuiAutocomplete: { defaultProps: { size: 'small' } },
    MuiIconButton: { defaultProps: { size: 'small' } },
    MuiToolbar: { defaultProps: { variant: 'dense' } },
    MuiListItemButton: { defaultProps: { dense: true } },
    // `initialState`, não `density`: a prop `density` é controlada e travaria o
    // seletor de densidade do GridActionsMenu. Uma grid que passar o próprio
    // `initialState` substitui este (sem merge) e precisa repetir a densidade.
    // `initialState` só vale na montagem: o GridCompactDensitySync ajusta a grid
    // já montada quando a janela cruza o xl.
    MuiDataGrid: { defaultProps: { initialState: { density: 'compact' } } },
  },
};

const dashboard = ({ compact }) => (compact ? compactOptions : {});

export default dashboard;
